module.exports = __webpack_public_path__ + "static/media/kahf.a73fa7c6.jpg";